/* eslint-disable react/prop-types */
import { DatePicker, Select, Space } from "antd"
import { useState } from 'react';
import moment from "moment"

export function DateField({
  id,
  name,
  onChange,
  placeholder = "Selecciona fecha...",
  defaultValue,
  fullWidth,
  value,
  range,
  delimiterMonths,
  delimiterMonthsObject,
  delimiterRange,
  disabledDateStart,
  disabledDateEnd,
  disabled = false,
  picker = "date",
  isSchedule = false,
  ...props
}) {

  const [typePicker, setType] = useState('date');

  const onDateChange = value => {
    
    if (value?.length > 0) {

      value = value?.map(v => v.format("YYYYMMDD"))
    }
    else {
      value = (isSchedule && typePicker === "month") ? value?.format("YYYYMM") : value?.format()
    }

    onChange && onChange({
      currentTarget: {
        id: id,
        value: value
      }
    },typePicker)
  }
  const { Option } = Select;


  if (isSchedule) {
    return(
      <Space>
      Filtrar por : 
      <Select aria-label="Picker Type" value={typePicker} onChange={setType}>
        <Option value="date">Día</Option>
        <Option value="month">Mes</Option>
      </Select>
      <DatePicker
      disabled={disabled}
      id={id}
      format={typePicker === "month" ? "MM/YYYY" : "DD/MM/YYYY"}
      picker={typePicker}
      name={name}
      style={fullWidth && { width: "100%" }}
      placeholder={typePicker === "month" ? "Seleccione Mes" : "Seleccione Día"}
      onChange={onDateChange}
      {...props} />
    </Space>
    )
  }

  if (range) {
    return (
      <DatePicker.RangePicker
        id={id}
        name={name}
        style={fullWidth && { width: "100%" }}
        defaultValue={defaultValue && defaultValue?.map(v => moment(v))}
        placeholder={placeholder}
        onChange={onDateChange}
        value={value && value?.map(v => moment(v))}
        {...props} />
    )
  }

  if(delimiterRange){
    const disabledDate = (current) => {
      // Deshabilita fechas que no están en en el rango de monitoreo 
      return current && (current < moment(disabledDateStart) || current > moment(disabledDateEnd));
    };

    return(<DatePicker
      disabled={disabled}
      disabledDate={disabledDate}
      id={id}
      picker={picker}
      name={name}
      style={fullWidth && { width: "100%" }}
      defaultValue={defaultValue && moment(defaultValue)}
      placeholder={placeholder}
      onChange={onDateChange}
      value={value && moment(value)}
      {...props} />)
  }

  if(delimiterMonths){
    
    const disabledDate = (current) => {
      if (!current) {
        return false;
      }
      const year = current.year();   
      const month = current.month(); 
  
      return delimiterMonthsObject.some(mesBloqueado => 
        mesBloqueado.year === year && mesBloqueado.month === month
      );
    };

    return(<DatePicker
      disabledDate={disabledDate}
      id={id}
      picker={picker}
      name={name}
      style={fullWidth && { width: "100%" }}
      defaultValue={defaultValue && moment(defaultValue)}
      placeholder={placeholder}
      onChange={onDateChange}
      value={value && moment(value)}
      {...props} />)

  }

  return (
    <DatePicker
      disabled={disabled}
      id={id}
      picker={picker}
      name={name}
      style={fullWidth && { width: "100%" }}
      defaultValue={defaultValue && moment(defaultValue)}
      placeholder={placeholder}
      onChange={onDateChange}
      value={value && moment(value)}
      {...props} />
  )
}
